import { Color, DefaultValue, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

interface ContentWrapperProps {
  isOpen: boolean
}

export const AccordionWrapper = styled.div`
  margin-bottom: ${Spacing.S12};
  border: 1px solid ${Color.Grey150};
  border-radius: ${DefaultValue.BorderRadius};
`

export const AccordionHeaderWrapper = styled.div`
  padding: ${Spacing.S16};
`

export const ContentWrapper = styled.div<ContentWrapperProps>`
  display: grid;
  overflow: hidden;
  transition:
    grid-template-rows 0.5s cubic-bezier(0.25, 0.8, 0.25, 1),
    padding 0.4s ease-in-out,
    opacity 0.35s ease-in-out ${({ isOpen }) => (isOpen ? '0s' : '0.1s')};

  ${({ isOpen }) =>
    isOpen
      ? css`
          opacity: 1;
          grid-template-rows: 1fr;
          padding: 0 ${Spacing.S16} ${Spacing.S16};
        `
      : css`
          opacity: 0;
          grid-template-rows: 0fr;
          padding: 0 ${Spacing.S16} 0;
        `}
`

export const ContentInner = styled.div`
  overflow: hidden;
`
